export default __webpack_public_path__ + "static/media/icon_left_align.2404ec16.svg";